"use client"

import { Button, showMoreBatchSize, cn } from '@yeshuman/sdk'
import { ChevronDown } from 'lucide-react'

export type SmartAnalysisResultsPaginationProps = {
  visibleCount: number
  totalCount: number
  unit: { singular: string; plural: string }
  onShowMore?: () => void
  onShowAll?: () => void
  className?: string
}

/** Ranked-results footer: show more (paged) and view all when the list is cropped. */
export function SmartAnalysisResultsPagination({
  visibleCount,
  totalCount,
  unit,
  onShowMore,
  onShowAll,
  className,
}: SmartAnalysisResultsPaginationProps) {
  if (totalCount === 0 || visibleCount >= totalCount) {
    return null
  }

  const hasMore = visibleCount < totalCount
  const batchSize = showMoreBatchSize(visibleCount, totalCount)
  const unitLabel = totalCount === 1 ? unit.singular : unit.plural

  return (
    <div
      className={cn(
        'flex flex-col items-center gap-2 border-t border-border/60 pt-3 sm:flex-row sm:justify-center',
        className,
      )}
    >
      <p className="text-sm text-muted-foreground tabular-nums">
        Showing {visibleCount} of {totalCount} {unitLabel}
      </p>
      <div className="flex flex-wrap items-center justify-center gap-2">
        {hasMore && onShowMore ? (
          <Button
            variant="ghost"
            size="sm"
            onClick={onShowMore}
            className="flex items-center gap-2"
          >
            <ChevronDown className="size-4" aria-hidden />
            Show {batchSize} more
          </Button>
        ) : null}
        {hasMore && onShowAll ? (
          <Button variant="outline" size="sm" onClick={onShowAll}>
            View all {totalCount} {unitLabel}
          </Button>
        ) : null}
      </div>
    </div>
  )
}
